import * as angular from 'angular';

import { ConnectionAutoRefreshToggleComponent } from '../../components/connection/connection-auto-refresh-toggle/connection-auto-refresh-toggle.component';
import { ConnectionEncryptionToggleComponent } from '../../components/connection/connection-encryption-toggle/connection-encryption-toggle.component';
import { ConnectionsBrowserComponent } from './connections-browser/connections-browser.component';
import { ConnectionModule } from '~/modules/org-settings/components/connection/connection.module';

/* prettier-ignore */
export const ConnectionsModule = angular
  .module('connections', [ConnectionModule])
  .component('connectionEncryptionToggle', ConnectionEncryptionToggleComponent)
  .component('connectionAutoRefreshToggle', ConnectionAutoRefreshToggleComponent)
  .component('connectionsBrowser', ConnectionsBrowserComponent)
  .name;
